import { ConcreteEncodable } from "./ConcreteEncodable";

import { ErrorsImplEncoder } from "../../encoder/ErrorsImplEncoder";

import * as CubiqTS from "../../index";
import { Errors } from "../Errors";

export class ErrorsImpl extends ConcreteEncodable implements Errors {
  public static enType: string = "com.bcdfx.broker.ErrorsImpl";

  /*FID=1*/
  public errorMessages: Array<CubiqTS.Message> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ErrorsImplEncoder.Instance;
    this.setEncodableType(ErrorsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ErrorsImpl[" + "errorMessages=" + this.errorMessages + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
